module.exports = __webpack_public_path__ + "img/1716350778376-WhatsApp Image 2024-05-22 at 10.38.21 1.jpeg.ad003e98.webp";